/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ActionContext, Module } from 'vuex';
import store from '@/store';
import RootStateType from '@/store/types';
import generateMutations, {
  UPDATE_STATE_TYPE,
} from '@/store/generate-mutations';
import PreApplyChoose from '@/api/preApplyChoose';
import { Vue } from 'vue-property-decorator';
import { ApplyOrderStatus, StateType } from './types';

// 间隔30s查询一次申请结果
const TIMER_INTERVAL = 1000 * 30;

const moduleStore: Module<StateType, RootStateType> = {
  namespaced: true,
  state: {
    timerId: null,
    applyData: null,
    bannerData: null,
  },
  actions: {
    // 验证额度申请结果
    async checkApplyResultWithInterval(
      context: ActionContext<StateType, RootStateType>,
      payload: {
        taskId?: string;
        orderId?: string;
      },
    ): Promise<void> {
      try {
        let applyData = null;
        if (payload.taskId) {
          applyData = await PreApplyChoose.getMultyPreApplyResult(
            payload.taskId,
          );
        }

        /** 外采授信订单 */
        if (payload.orderId) {
          applyData = await PreApplyChoose.getSourcePreApplyResult(
            payload.orderId,
          );
        }

        context.dispatch(UPDATE_STATE_TYPE, {
          applyData,
          timerId: null,
        });

        if (applyData) {
          // 如果尚未有结果，则间隔一定的时间继续轮询
          if (applyData.status === ApplyOrderStatus.SUBMITTING) {
            context.dispatch(UPDATE_STATE_TYPE, {
              timerId: setTimeout(() => {
                context.dispatch('checkApplyResultWithInterval', {
                  taskId: payload.taskId,
                  orderId: payload.orderId,
                });
              }, TIMER_INTERVAL),
            });
          }
        }


        return Promise.resolve();
      } catch (err) {
        return Promise.resolve();
      }
    },
    // 获取process页面的banner配置
    async getBannerConfig(
      context: ActionContext<StateType, RootStateType>,
    ): Promise<void> {
      try {
        context.dispatch(UPDATE_STATE_TYPE, {
          bannerData: await Vue.prototype.$tangram.getConfigValue({
            moduleCode: 'financial',
            keyCode: 'AppFinanceH5Web.PreApplyResult.BannerData',
          }),
        });

        return Promise.resolve();
      } catch (err) {
        return Promise.resolve();
      }
    },
  },
};

store.registerModule(
  'preApplyResult',
  generateMutations<StateType>(moduleStore),
);
